"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNewsletterUploadInfo = exports.TagsData = exports.CategoriesData = exports.TempDownloadUrlData = exports.NewsletterData = exports.NewslettersData = exports.NewsletterFragment = exports.CategoryFragment = exports.TagFragment = void 0;
const tslib_1 = require("tslib");
const client_1 = require("@apollo/client");
const client_2 = tslib_1.__importDefault(require("../helpers/client"));
const utils_1 = require("../helpers/utils");
// Tag
exports.TagFragment = (0, client_1.gql) `
  fragment TagFragment on Tag {
    id
    name
    description
  }
`;
// Category
exports.CategoryFragment = (0, client_1.gql) `
  fragment CategoryFragment on Category {
    id
    name
    description
  }
`;
exports.NewsletterFragment = (0, client_1.gql) `
  fragment NewsletterFragment on Newsletter {
    id
    publishYear
    publishMonth
    name
    description
    key
    issue
    downloadUrl
    tags {
      ...TagFragment
    }
    category {
      ...CategoryFragment
    }
  }
  ${exports.TagFragment}
  ${exports.CategoryFragment}
`;
const NEWSLETTERS_QUERY = (0, client_1.gql) `
  query newsletters(
    $before: String
    $after: String
    $first: Int
    $last: Int
    $searchText: String
    $skip: Int
    $tagId: String
    $categoryId: String
    $group: GroupByEnum
  ) {
    newsletters(
      before: $before
      after: $after
      first: $first
      last: $last
      searchText: $searchText
      skip: $skip
      tagId: $tagId
      categoryId: $categoryId
      group: $group
    ) {
      edges {
        node {
          ...NewsletterFragment
        }
        cursor
      }
      pageInfo {
        startCursor
        endCursor
        hasPreviousPage
        hasNextPage
      }
    }
  }
  ${exports.NewsletterFragment}
`;
exports.NewslettersData = (0, utils_1.buildQuery)({
    query: NEWSLETTERS_QUERY,
    defaultVariables: {
        first: 10,
    },
    fetchMoreOpts: ({ variables, data }) => {
        const pageInfo = data && data.newsletters && data.newsletters.pageInfo;
        if (!pageInfo || !pageInfo.hasNextPage) {
            return undefined;
        }
        return {
            variables: { first: variables === null || variables === void 0 ? void 0 : variables.first, after: pageInfo.endCursor },
            updateQuery: (p, { fetchMoreResult }) => {
                if (!fetchMoreResult || !fetchMoreResult.newsletters) {
                    return p;
                }
                const pEdges = p.newsletters.edges || [];
                const nEdges = fetchMoreResult.newsletters.edges || [];
                return {
                    newsletters: {
                        ...p.newsletters,
                        edges: [...pEdges, ...nEdges],
                        pageInfo: fetchMoreResult.newsletters.pageInfo,
                    },
                };
            },
        };
    },
});
const NEWSLETTER_QUERY = (0, client_1.gql) `
  query Newsletter($id: ID!) {
    Newsletter(id: $id) {
      ...NewsletterFragment
    }
  }
  ${exports.NewsletterFragment}
`;
exports.NewsletterData = (0, utils_1.buildQuery)({
    query: NEWSLETTER_QUERY,
});
const GET_TEMP_DOWNLOAD_URL_QUERY = (0, client_1.gql) `
  query getTempDownloadUrl($id: String!) {
    getTempDownloadUrl(id: $id)
  }
`;
exports.TempDownloadUrlData = (0, utils_1.buildQuery)({
    query: GET_TEMP_DOWNLOAD_URL_QUERY,
});
// Category
const CATEGORIES_QUERY = (0, client_1.gql) `
  query categories($before: String, $after: String, $first: Int, $last: Int) {
    categories(before: $before, after: $after, first: $first, last: $last) {
      edges {
        node {
          ...CategoryFragment
        }
        cursor
      }
      pageInfo {
        startCursor
        endCursor
        hasPreviousPage
        hasNextPage
      }
    }
  }
  ${exports.CategoryFragment}
`;
exports.CategoriesData = (0, utils_1.buildQuery)({
    query: CATEGORIES_QUERY,
    defaultVariables: {
        first: 10,
    },
    fetchMoreOpts: ({ variables, data }) => {
        const pageInfo = data && data.categories && data.categories.pageInfo;
        if (!pageInfo || !pageInfo.hasNextPage) {
            return undefined;
        }
        return {
            variables: { first: variables === null || variables === void 0 ? void 0 : variables.first, after: pageInfo.endCursor },
            updateQuery: (p, { fetchMoreResult }) => {
                if (!fetchMoreResult || !fetchMoreResult.categories) {
                    return p;
                }
                const pEdges = p.categories.edges || [];
                const nEdges = fetchMoreResult.categories.edges || [];
                return {
                    categories: {
                        ...p.categories,
                        edges: [...pEdges, ...nEdges],
                        pageInfo: fetchMoreResult.categories.pageInfo,
                    },
                };
            },
        };
    },
});
// TAG
const TAGS_QUERY = (0, client_1.gql) `
  query CountTags(
    $searchText: String
    $before: String
    $after: String
    $first: Int
    $last: Int
    $skip: Int
    $tagId: String
    $categoryId: String
    $group: GroupByEnum
  ) {
    countTags(
      searchText: $searchText
      before: $before
      after: $after
      first: $first
      last: $last
      skip: $skip
      tagId: $tagId
      categoryId: $categoryId
      group: $group
    ) {
      edges {
        node {
          ...TagFragment
          newsletterCount
        }
        cursor
      }
      pageInfo {
        startCursor
        endCursor
        hasPreviousPage
        hasNextPage
      }
    }
  }
  ${exports.TagFragment}
`;
exports.TagsData = (0, utils_1.buildQuery)({
    query: TAGS_QUERY,
    defaultVariables: {
        first: 10,
    },
});
const GENERATE_UPLOAD_URL = (0, client_1.gql) `
  query uploadUrl {
    generateNewsletterUploadInfo {
      key
      uploadUrl
    }
  }
`;
const getNewsletterUploadInfo = () => client_2.default.getClient().query({ query: GENERATE_UPLOAD_URL, fetchPolicy: 'network-only' });
exports.getNewsletterUploadInfo = getNewsletterUploadInfo;
